var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", [
      _c("strong", [
        _vm._v(_vm._s(_vm.item.formattedGuest_id || _vm.item.patient_RegId)),
      ]),
    ]),
    _c("div", [
      _vm._v(
        "\n    " +
          _vm._s(_vm.item.firstname || _vm.item.name) +
          " " +
          _vm._s(_vm.item.middlename) +
          " " +
          _vm._s(_vm.item.lastname) +
          "\n  "
      ),
    ]),
    _c("div", [_vm._v(_vm._s(_vm.item.mobile))]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }